<template>
    <FormSection title="Payment Source" type="his-section" :full-height="false" :application-id="Number(application)">
        <template v-slot:content>
            <section class="row py-3 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center field-title">
                        <span class="badge me-1">M0150</span> Current Payment Sources for Home Care (mark all that
                        apply) <span class="text-danger">*</span>
                    </p>
                    <div
                        :class="`${
                            v$.referral.Demographics.PaymentSources.$error ||
                            errors.Demographics.includes('PaymentSources')
                                ? 'border border-warning rounded p-2'
                                : ''
                        }`"
                    >
                        <div v-for="option of paymentOptions" :key="`${option.value}-${option.label}`">
                            <div v-if="showOption(option)" class="form-check pb-2 ms-2">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="`${option.value}-${option.label}`"
                                    :value="option.value"
                                    :checked="referral.Demographics.PaymentSources.includes(option.value)"
                                    @change="handlePaymentSource(option.value)"
                                    @blur="v$.referral.Demographics.PaymentSources.$touch"
                                />
                                <label class="form-check-label" :for="`${option.value}-${option.label}`">
                                    <small>{{ option.label }}</small>
                                </label>
                            </div>
                        </div>
                    </div>
                    <template v-if="referral.Demographics.PaymentSources.includes('12')">
                        <div class="d-flex mt-2 bg-white flex-column p-2 pb-4 ms-4 w-40">
                            <label class="service-required-text-color">Other Payment Source </label>
                            <input
                                type="text"
                                class="form-control w-90"
                                placeholder="Enter Payment Source"
                                v-model="referral.Demographics.OtherPaymentSource"
                                maxlength="300"
                            />
                        </div>
                    </template>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PaymentSource.ts"></script>
